import { observable, set } from 'mobx';

export interface IAsset {
    alt: string;
    height: number;
    position: number;
    src: string;
    type: string;
    width: number;
    assetType?: string;
}

export class Asset {
    @observable public src: string = '';
    @observable public alt: string = '';
    @observable public assetType?: string = '';
    public height: number;
    public position: number;
    public type: string = '';
    public width: number;

    public static fromJson(asset?: IAsset): Asset {
        const newAsset = new Asset();
        if (asset) {
            set(newAsset, asset);
        }

        return newAsset;
    }
}
